import { render, staticRenderFns } from "./bidAnnouncementPublish.vue?vue&type=template&id=78acf13a&scoped=true"
import script from "./bidAnnouncementPublish.vue?vue&type=script&lang=js"
export * from "./bidAnnouncementPublish.vue?vue&type=script&lang=js"
import style0 from "./bidAnnouncementPublish.vue?vue&type=style&index=0&id=78acf13a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78acf13a",
  null
  
)

export default component.exports